// eslint-disable-next-line import/no-cycle
import linkAccountFormModal from 'purchase/checkout/linkAccount/linkAccountFormModal';
// eslint-disable-next-line import/no-cycle
import LinkAccountConfirmationModal from 'purchase/checkout/linkAccount/LinkAccountConfirmationModal';
import ModalManager from 'global/modal/ModalManager';

export const getUrl = elementId => {
	const element = document.getElementById(elementId);
	return element.getAttribute('data-url');
};

export const showSpinner = () => {
	const button = document.getElementById(
		'customerLinkAccountFormModalActionLink',
	);
	if (button) {
		button.classList.add('btn--is-waiting');
	}
};

export const hideSpinner = () => {
	const button = document.getElementById(
		'customerLinkAccountFormModalActionLink',
	);
	if (button) {
		button.classList.remove('btn--is-waiting');
	}
};

export const handleResponse = res => {
	hideSpinner();
	if (res.status === 200) {
		const html = res.data;
		const modalId = 'customerLinkAccountFormModal';
		const newModalId = html.includes(modalId)
			? modalId
			: 'customerLinkAccountConfirmationModal';

		const modal = new ModalManager();
		modal.insertResponse(html, modalId);

		if (newModalId === modalId) {
			linkAccountFormModal();
		} else {
			const prevModal = document.getElementById(newModalId);
			if (prevModal) prevModal.remove();
			document.getElementById(modalId).id = newModalId;
			return Promise.resolve(new LinkAccountConfirmationModal());
		}
		return Promise.resolve(null);
	}
	return Promise.reject(new Error('Invalid response from server'));
};
